import SimpleLinkWrapper from '@components/bits/SimpleLinkWrapper';
import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';

type Props = {
  copyright: { elements };
  misc: { elements };
};

const FooterMiscColumn: FunctionComponent<Props> = ({
  copyright: { elements: copyright },
  misc: { elements: misc },
}) => {
  return (
    <>
      <div className={styles['_cookie']}>
        {misc?.map((val, key) => {
          return (
            <React.Fragment key={key}>
              <SimpleLinkWrapper cta={val}>
                <a className={styles['_cookie__middle']}>{val.title}</a>
              </SimpleLinkWrapper>
              {key < misc.length - 1 && <div className={styles['_divider']}>•</div>}
            </React.Fragment>
          );
        })}
      </div>
      <div className={styles['_shadow']}>
        {copyright?.map((val, key) => {
          return (
            <React.Fragment key={key}>
              <SimpleLinkWrapper cta={val}>
                <a>{val.title}</a>
              </SimpleLinkWrapper>
              {key < misc.length - 2 && <div className={styles['_divider']}>—</div>}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default React.memo(FooterMiscColumn);
